import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "../components/Header";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
} from "@material-ui/core";
import PatientStatus from "../components/PatientStatus";
import moment from "moment";
import { cndURL, sdkWrapperURL } from "../Util/ApiAxios";
import axios from "axios";
import calendericon from "../images/calendar-icon.svg";
import Prev from "../images/prev.svg";
import Next from "../images/next.svg";
import Loader from "react-loader-spinner";

function MyCalendar() {
  const classes = useStyles();
  const [filters, setFilters] = useState({
    All: true,
    Doctor: false,
    Nurse: false,
    "Health Coach": false,
  });
  const [scheduleEvents, setScheduleEvents] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const [isLoading, setLoading] = React.useState(false);

  const filterUserType = (type) => {
    if (type === "All") {
      setFilters({
        All: true,
        Doctor: false,
        Nurse: false,
        "Health Coach": false,
      });
    } else {
      setFilters((prev) => ({
        ...prev,
        [type]: !prev[type],
        All: false,
      }));
    }
  };

  const monthChange = (direction) => {
    const newMonth =
      direction === "prev"
        ? currentMonth.subtract(1, "months")
        : currentMonth.add(1, "months");
    setCurrentMonth(newMonth);
    setStartDate(newMonth.startOf("month").format("YYYY-MM-DD"));
    setEndDate(newMonth.endOf("month").format("YYYY-MM-DD"));
  };

  useEffect(() => {
    const getSchedule = async () => {
      setLoading(true);

      try {
        const refreshToken = await axios.post(
          sdkWrapperURL("/auth/refresh-token"),
          {
            platform_name: "DHCT",
            response_platform_name: "CARENOWDOC",
          },
          {
            headers: {
              Authorization: localStorage.getItem("dhct_Token"),
            },
          }
        );

        if (refreshToken.data.statusCode !== 200) {
          throw new Error("Failed to refresh token.");
        }

        const newToken = refreshToken.data.token;

        const scheduleResponse = await axios.post(
          cndURL("/cnd/doctor/calendar/visibility"),
          {
            start_date: startDate,
            end_date: endDate,
            category_type: ["Tele-consult Schedule", "IN-Person Schedule"],
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: newToken,
            },
          }
        );

        if (scheduleResponse.data.statusCode !== 200) {
          throw new Error(
            scheduleResponse.data.message || "Failed to fetch schedule"
          );
        }

        const scheduleData = scheduleResponse.data.body;
        const formattedEvents = [];

        const SALUTATION_MAP = {
          Doctor: "D",
          Nurse: "N",
          "Health Coach": "H",
        };

        const SCHEDULE_TYPE_MAP = {
          "2f1c0f37-4f45-4e8a-a238-a6e38e25395a": "I",
          "822743ca-a4c8-4fe6-bcbf-ff7b585c3834": "T",
        };

        for (const dayObj of scheduleData) {
          const dateKey = Object.keys(dayObj)[0];
          const entries = dayObj[dateKey];
          const formattedDate = moment(dateKey).format("YYYY-MM-DD");

          for (const entry of entries) {
            const name = entry.doctor_name;
            const type = entry.user_type;
            const salutation = SALUTATION_MAP[type] || "";

            for (const [scheduleId, label] of Object.entries(
              SCHEDULE_TYPE_MAP
            )) {
              const data = entry[scheduleId];
              if (!data) continue;

              if (typeof data === "string") {
                const [start, end] = data
                  .split(" - ")
                  .map((d) => d.split("+")[0]);
                const startTime = moment
                  .utc(`${formattedDate} ${start}`, "YYYY-MM-DD HH:mm:ss")
                  .toDate();
                const endTime = moment
                  .utc(`${formattedDate} ${end}`, "YYYY-MM-DD HH:mm:ss")
                  .toDate();

                formattedEvents.push({
                  title: `(${label}) ${salutation}. ${name}`,
                  start: startTime,
                  end: endTime,
                  type,
                  date: formattedDate,
                });
              }
              if (Array.isArray(data)) {
                for (const slotObj of data) {
                  for (const slotKey in slotObj) {
                    const timeRange = slotObj[slotKey];
                    if (timeRange) {
                      const [start, end] = timeRange.split(" - ");
                      const startTime = moment
                        .utc(`${formattedDate}T${start}`)
                        .toDate();
                      const endTime = moment
                        .utc(`${formattedDate}T${end}`)
                        .toDate();

                      formattedEvents.push({
                        title: `(${label}) ${salutation}. ${name}`,
                        start: startTime,
                        end: endTime,
                        type,
                        date: formattedDate,
                      });
                    }
                  }
                }
              }
            }
          }
        }

        setScheduleEvents(formattedEvents);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    getSchedule();
  }, [startDate, endDate]);

  const getEventStyle = (type) => {
    switch (type) {
      case "Doctor":
        return {
          backgroundColor: "#CAE4B5",
          textColor: "#00451F",
        };
      case "Nurse":
        return {
          backgroundColor: "#E4CBB3",
          textColor: "#82470B",
        };
      case "HealthCoach":
      case "Health Coach":
        return {
          backgroundColor: "#C9D5F2",
          textColor: "#2952B4",
        };
      default:
        return {
          backgroundColor: "#eee",
          textColor: "#333",
        };
    }
  };

  const filteredEvents =
    filters.All || Object.values(filters).every((v) => !v)
      ? scheduleEvents
      : scheduleEvents.filter((event) => filters[event.type]);

  const daysInMonth = currentMonth.daysInMonth();

  const days = Array(daysInMonth)
    .fill()
    .map((_, i) => currentMonth.clone().date(i + 1));

  return (
    <div>
      <Header />
      <Box className={classes.Pagecontent}>
        <Box className={classes.Leftcol}>
          <Box className={classes.leftnav} style={{ marginTop: "40px" }}>
            {localStorage.getItem("dhct_JWT") ? <PatientStatus /> : null}
          </Box>
        </Box>

        <Box className={classes.Rightcol}>
          <Typography style={{ fontSize: "28px", marginBottom: 20 }}>
            Schedules
          </Typography>
          {isLoading ? (
            <Loader
              type="ThreeDots"
              color="#114ebd"
              height={75}
              width={75}
              timeout={0}
              className={classes.loader}
            />
          ) : (
            <>
              <Box className={classes.monthNavigation}>
                <Button
                  onClick={() => monthChange("prev")}
                  className={classes.icons}
                >
                  <img src={Prev} alt="prev icon" />
                </Button>
                <Button
                  onClick={() => monthChange("next")}
                  className={classes.icons}
                >
                  <img src={Next} alt="next icon" />
                </Button>
                <Box className={classes.monthLabel}>
                  {currentMonth.format("MMMM YYYY")}
                  <img
                    src={calendericon}
                    alt="calendar icon"
                    style={{ marginLeft: 30, marginRight: 20 }}
                  />
                </Box>
              </Box>
              <Box className={classes.calendarbox}>
                <Box
                  style={{
                    display: "flex",
                    gap: 20,
                    marginBottom: "20px",
                    marginLeft: "20px",
                    marginTop: "20px",
                  }}
                >
                  {["All", "Doctor", "Nurse", "Health Coach"].map((type) => (
                    <FormControlLabel
                      key={type}
                      control={
                        <Checkbox
                          checked={filters[type]}
                          onChange={() => filterUserType(type)}
                          color="primary"
                          style={{
                            color: filters[type] ? "#4CAF50" : undefined,
                          }}
                        />
                      }
                      label={type}
                    />
                  ))}
                </Box>
                <hr style={{ backgroundColor: "#ddd", opacity: 0.5 }} />
                <Box className={classes.weekHeader}>
                  {[
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                  ].map((dayName) => (
                    <Box key={dayName} className={classes.dayNameHeader}>
                      {dayName}
                    </Box>
                  ))}
                </Box>
                <hr style={{ backgroundColor: "#ddd", opacity: 0.5 }} />
                <Box style={{ maxHeight: "900px", overflowY: "auto" }}>
                  <div className={classes.monthGrid}>
                    {days.map((day, index) => {
                      const dayEvents = filteredEvents.filter((event) =>
                        moment(event.date).isSame(day, "day")
                      );

                      const gridColumnStart =
                        index === 0 ? day.day() + 1 : undefined;
                      return (
                        <Box
                          key={day.format("YYYY-MM-DD")}
                          className={classes.dayBox}
                          style={{ gridColumnStart }}
                        >
                          <Box className={classes.dayHeader}>
                            {day.format("D")}
                          </Box>
                          <Box className={classes.eventList}>
                            {dayEvents.map((event, index) => {
                              const { backgroundColor, textColor } =
                                getEventStyle(event.type);
                              return (
                                <Box
                                  key={index}
                                  className={classes.event}
                                  style={{
                                    backgroundColor,
                                    color: textColor,
                                    fontSize: 12,
                                    padding: 6,
                                    borderRadius: 4,
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 8,
                                  }}
                                >
                                  <Box
                                    style={{
                                      width: 10,
                                      height: 10,
                                      background: textColor,
                                      borderRadius: "50%",
                                      flexShrink: 0,
                                    }}
                                  ></Box>
                                  <Box>
                                    {moment
                                      .utc(event.start)
                                      .local()
                                      .format("hh:mm A")}{" "}
                                    -{" "}
                                    {moment
                                      .utc(event.end)
                                      .local()
                                      .format("hh:mm A")}{" "}
                                    {event.title}
                                  </Box>
                                </Box>
                              );
                            })}
                          </Box>
                        </Box>
                      );
                    })}
                  </div>
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </div>
  );
}

export default MyCalendar;

const useStyles = makeStyles(() => ({
  Pagecontent: {
    display: "flex",
    textAlign: "left",
    width: "100%",
  },
  Leftcol: {
    width: "15%",
    padding: "20px 3%",
    minHeight: "800px",
    background: "linear-gradient(45deg, #114ebd, #0f3d6e)",
  },
  Rightcol: {
    width: "75%",
    padding: "20px 2%",
    borderLeft: "1px #F6F6F6 solid",
  },
  monthNavigation: {
    display: "flex",
    justifyContent: "left",
    alignItems: "left",
    marginBottom: "20px",
    backgroundColor: "#DFE7FE",
    padding: "25px",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  monthLabel: {
    display: "flex",
    alignItems: "center",
    borderRadius: 10,
    fontSize: "16px",
    fontWeight: "normal",
    backgroundColor: "white",
    padding: "7px",
    paddingLeft: "15px",
  },
  monthGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    gridGap: "10px",
    marginTop: "20px",
  },
  calendarbox: {
    border: "1px solid #ddd",
  },
  dayBox: {
    border: "1px solid #ddd",
    padding: "5px",
    borderRadius: "6px",
    height: "200px",
    overflowY: "auto",
  },
  dayHeader: {
    fontWeight: "bold",
    textAlign: "center",
  },
  eventList: {
    maxHeight: "150px",
    overflowY: "auto",
    padding: "5px",
  },
  event: {
    marginBottom: "5px",
    padding: "5px",
    borderRadius: "4px",
    color: "white",
  },
  icons: {
    height: 40,
    backgroundColor: "white",
    borderRadius: 10,
    marginRight: 10,
  },
  loader: {
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
  },
  dayName: {
    fontSize: "12px",
    fontWeight: "bold",
    color: "#666",
    textAlign: "center",
    marginBottom: 4,
  },
  weekHeader: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    padding: "8px 0",
    backgroundColor: "#fff",
    textAlign: "center",
    fontWeight: 600,
    fontSize: 14,
    color: "#333",
  },

  dayNameHeader: {
    padding: "8px 0",
  },
  customHr: {
    height: 5,
    backgroundColor: "#ddd",
    opacity: 0.5,
  },
}));
